import { render, staticRenderFns } from "./Polkadot.vue?vue&type=template&id=6f19c28e&scoped=true&"
import script from "./Polkadot.vue?vue&type=script&lang=js&"
export * from "./Polkadot.vue?vue&type=script&lang=js&"
import style0 from "./Polkadot.vue?vue&type=style&index=0&id=6f19c28e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f19c28e",
  null
  
)

export default component.exports